import {query, transition, trigger, useAnimation} from '@angular/animations';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {faPencil} from '@fortawesome/free-solid-svg-icons';
import {faPenToSquare} from '@fortawesome/pro-duotone-svg-icons';
import {ButtonTypeEnum, IspColoursEnum, SizeEnum} from '@i-supplier/angular-shared-module';
import {slideIn50StaggerAnimation} from '../../../../shared/animation/common.animation';
import {ListContentComponent} from '../../../../shared/components/list-content/list-content.component';
import {ListContentModel} from '../../../../shared/models/list-content.model';
import {MenuItemModel} from '../../../../shared/models/menu-item.model';
import {InvoiceAdvancedSearchModel} from '../../models/invoice-advanced-search.model';
import {InvoiceService} from '../../services/invoice.service';

@Component({
  selector: 'regulations-to-generate',
  templateUrl: './regulations-to-generate.component.html',
  styleUrls: ['./regulations-to-generate.component.scss'],
  animations: [
    trigger('slideInStagger', [
      transition(':enter', [
        query('.slide-in-animation', [
          useAnimation(slideIn50StaggerAnimation)
        ], {optional: true})
      ])
    ])
  ]
})
export class RegulationsToGenerateComponent extends ListContentComponent implements OnInit {
  purchaseOrderBlocked: string[];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private invoiceService: InvoiceService
  ) {
    super(router, route);
  }
  protected readonly faPencil = faPencil;
  listParamValidator = {
    page: RegExp('^[1-9][0-9]*$'),
    size: ['5', '10', '20'],
    sort: RegExp('^(firstName|email|contact\.phones\.workPhoneNumber|date)\,(asc|desc)$'),
    search: RegExp('.{3,}'),
  };
  menu: MenuItemModel[] = [];

  protected readonly SizeEnum = SizeEnum;
  protected readonly faPenToSquare = faPenToSquare;
  protected readonly IspColoursEnum = IspColoursEnum;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;

  ngOnInit(): void {
    this.sort = 'id';
    this.sortDirection = 'asc';
    super.ngOnInit();
    this.subscribeToQueryParam();
    this.verifyInvoices();
  }

  private verifyInvoices(): void {
    if (!this.listContent)
      return;
    const pos = this.listContent.map(group => group.purchaseOrderNumber);
    const search = new InvoiceAdvancedSearchModel();
    search.status = 'TRANSMITTED';
    search.types = ['SUPPLIER_CREDIT_NOTE'];
    this.purchaseOrderBlocked = [];
    this.invoiceService.getInvoicesByPage(0, 2000, null, null, search).subscribe({
      next: value => {
        for (const invoice of value.content) {
          for (const purchaseOrder of invoice.purchaseOrders) {
            if (!pos.includes(purchaseOrder)) {
              continue;
            }
            this.purchaseOrderBlocked.push(purchaseOrder);
          }
        }
      },
    });
  }

  retrieveListContent(params: any): void {
    const page = params.page ? params.page - 1 : 0;
    const size = 2000;
    const sort = params.sort ? params.sort : 'id,asc';
    const search = params.search ? params.search : null;
    this.invoiceService.getRegulationsWaitingForGeneration(page, size, sort, search).subscribe({
      next: (res: ListContentModel) => {
        this.listContent = res.content;
        this.verifyInvoices();
        this.totalElements = res.totalElements;
        this.numberOfElements = res.numberOfElements;
        this.isListEmpty = !this.isSearchActive && res.empty;
        if (res.totalPages !== 0 && params.page > res.totalPages) {
          this.updateQueryParam({page: res.totalPages});
        }
        this.firstCallDone = true;
      }
    });
  }

  generateInvoice(fee: any) {
    this.router.navigate(['/accounting/regulation/', fee.regulationIds.toString(), 'proforma-generation']);
  }
}
